import React from "react";

import ChoosPayMethoud from "../../Components/Checkout/ChoosPayMethoud";

const PaymentMethodPage = () => {
  return (
    <div className="container" style={{height: "670px"}}>
    <ChoosPayMethoud/>
    </div>
  );
};

export default PaymentMethodPage;
